var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionsIconOutlined(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.536 13.37h2.051a.913.913 0 0 0 .913-.913v-.914a.913.913 0 0 0-.913-.913h-2.052a10.774 10.774 0 0 0-.913-2.667l1.451-1.45a.913.913 0 0 0 0-1.291L18.778 3.93a.913.913 0 0 0-1.29 0l-1.452 1.45a10.746 10.746 0 0 0-2.666-.913V2.413a.913.913 0 0 0-.913-.913h-.914a.913.913 0 0 0-.913.913v2.053c-.925.186-1.821.493-2.667.914L6.512 3.93a.913.913 0 0 0-1.291 0L3.929 5.223a.913.913 0 0 0 0 1.292l1.451 1.45c-.42.846-.726 1.742-.913 2.667H2.413a.913.913 0 0 0-.913.913v.913c0 .505.409.913.913.913h2.05c.187.926.494 1.822.914 2.667L3.925 17.49a.913.913 0 0 0 0 1.291l1.296 1.291a.913.913 0 0 0 1.29 0l1.452-1.451c.845.42 1.742.726 2.667.913v2.054c0 .504.41.913.913.913h.914a.913.913 0 0 0 .913-.913v-2.05a10.774 10.774 0 0 0 2.666-.913l1.452 1.451a.913.913 0 0 0 1.291 0l1.291-1.291a.913.913 0 0 0 0-1.291l-1.45-1.452c.42-.846.729-1.745.916-2.671z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.001,
    r: 4.109
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsIconOutlined);
export default __webpack_public_path__ + "static/media/actions-icon-outlined.2e87232ef5572922c0b0c562f9913ba1.svg";
export { ForwardRef as ReactComponent };